module.exports = __webpack_public_path__ + "img/page-header-background-chart.802b8e98.svg";